import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * GlowCard — premium animated card.
 * Variants:
 *   - default (glass-card)
 *   - liquid  (liquid-glass)
 *   - glow    (animated gradient border on hover)
 *
 * Adds subtle hover lift via framer-motion.
 */
const GlowCard = React.forwardRef(
  ({ variant = "default", className = "", children, hoverable = true, ...rest }, ref) => {
    const baseClass =
      variant === "liquid" ? "liquid-glass" :
      variant === "glow"   ? "glow-card"   :
                             "glass-card";

    const hoverProps = hoverable
      ? { whileHover: { y: -4 }, transition: { type: "spring", stiffness: 240, damping: 20 } }
      : {};

    return (
      <motion.div
        ref={ref}
        className={cn(baseClass, "p-6", className)}
        {...hoverProps}
        {...rest}
      >
        {children}
      </motion.div>
    );
  },
);

GlowCard.displayName = "GlowCard";

export default GlowCard;
